import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import { memo, useCallback } from 'react';
import { setSliceOpenPromptInputAction, setSlicePromptAction } from '../../../redux/slices/FJSliceImageToImage';
import FJPromptInput from './FJPromptInput';

const FJPromptInputContainer = memo(() => {
    useLocalStore();
    const dispatch = useDispatch();
    const prompt = useSelector(state => state.imageToImage.prompt);
    const openPromptInput = useSelector(state => state.imageToImage.openPromptInput);

    const changePrompt = useCallback(
        value => {
            dispatch(setSlicePromptAction(value));
        },
        [dispatch],
    );

    const changeOpenPromptInput = useCallback(() => {
        dispatch(setSliceOpenPromptInputAction(!openPromptInput));
    }, [dispatch, openPromptInput]);

    return (
        <FJPromptInput
            prompt={prompt}
            changePrompt={changePrompt}
            isOpenPromptInput={openPromptInput}
            changeOpenPromptInput={changeOpenPromptInput}
        />
    );
});

FJPromptInputContainer.displayName = 'FJPromptInputContainer';

export default FJPromptInputContainer;
